const PROPERTY_DRAFT_TAG_TYPES = {
  PROPERTY_DRAFT_LIST: "PROPERTY_DRAFT_LIST",
  PROPERTY_DRAFT_DETAIL: "PROPERTY_DRAFT_DETAIL",
  PROPERTY_DRAFT_DELETE: "PROPERTY_DRAFT_DELETE",
  PROPERTY_DRAFT_DELETE_ALL: "PROPERTY_DRAFT_DELETE_ALL",
  PROPERTY_DRAFT_UPDATE: "PROPERTY_DRAFT_UPDATE"
};

export const PROPERTY_DRAFT_TAGS = Object.values(PROPERTY_DRAFT_TAG_TYPES);
export default PROPERTY_DRAFT_TAG_TYPES;
